import Vue from 'vue'
import axios from 'axios'
import { processMatch } from '@/store/modules/matches/matchDetail'

// state
export const state = {
  isMatchStatsLoading: false,
  selectedMatch: false,
  all: {},
}

// getters
export const getters = {
  getMatchStats: ({ all }) => (matchId) => all[matchId] || [],
}
// mutations
export const mutations = {
  fetchMatchStatsStarted(state) {
    state.isMatchStatsLoading = true
  },
  // eslint-disable-next-line camelcase
  fetchMatchStatsSuccess(state, { matchId, stats: { history, score_team1, score_team2, ...rest } }) {
    const now = new Date()
    Vue.set(state.all, matchId, processMatch({
      ...rest,
      // eslint-disable-next-line camelcase
      scoreTeam1: score_team1 === null ? 0 : parseInt(score_team1),
      // eslint-disable-next-line camelcase
      scoreTeam2: score_team2 === null ? 0 : parseInt(score_team2),
      history: history.map((match) => processMatch(match, now)),
    }, now))
    state.isMatchStatsLoading = false
  },
  fetchMatchStatsFailed(state) {
    state.isMatchStatsLoading = false
  },
}
// actions
export const actions = {
  async fetchMatchStats({ commit, state: { all } }, { matchId }) {
    if (typeof all[matchId] !== 'undefined') {
      return all[matchId]
    }
    let stats = null
    try {
      commit('fetchMatchStatsStarted')
      stats = await axios.get(`match/${matchId}/stats`)
      commit('fetchMatchStatsSuccess', {
        matchId,
        stats,
      })
    } catch (e) {
      commit('fetchMatchStatsFailed')
    }
    return stats
  },
}
